import React, { Component } from 'react';
import {
    Link,
    Redirect
} from "react-router-dom";
import './Recharge.css';
import moment from 'moment';
import axios from 'axios';
import Loading from '../../Components/Loading/Loading';
import 'react-credit-cards/es/styles-compiled.css';
import NumberFormat from 'react-number-format';
import Swal from 'sweetalert2';
import withReactContent from "sweetalert2-react-content";
import ProgressCircleWrapper from '../ProgressCircleWrapper';
import successIcon from "../../images/successicon.png"
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

import { transactionID } from "../../services/helpers";


class MyProgramStep extends Component {

    constructor(props) {
        super(props);

        let clientInfo = JSON.parse(localStorage.getItem('clientInfo'));


        //console.log(localStorage.getItem('clientInfo'));
        axios.defaults.headers.common['Authorization'] = "Bearer " + clientInfo.accessToken;
        axios.defaults.headers.common['Content-Type'] = "application/json";

        this.state = {
            clientInfo: clientInfo,
            loading: 0,
            cpf: "",
            showPopUpSucess: false,
            redirect: false,
            amount: 0,
            date: "00/00",
            paymentFlag: "",
            paymentLastNumber: "",
            days: 0,
            dateFull: "",
            cardList: [],
            programID: "",
            isIntelligentControl: false,
            textPolity: "",
            textList: [],
            whatStep: "init",
            motivoId: ""

        }

    }

    formartDate = (date) => {
        return date.split(" ")[0].split("-")[2] + "/" + date.split(" ")[0].split("-")[1] + "/" + date.split(" ")[0].split("-")[0]
    }

    queryProgram = () => {

        axios.post('https://www.pagtel.com.br/Hub360Correios/v2/queryProgram', {
            transactionId: transactionID('ABN'),
            msisdn: JSON.parse(localStorage.getItem("clientInfo")).number

        }, { headers: { "Authorization": "Bearer " + JSON.parse(localStorage.getItem("clientInfo")).accessToken } }).then((response) => {

            switch (response.data.code) {
                case 'P00':
                    let thisCard = this.state.cardList.filter(function (item) {
                        return item.paymentID === response.data.program[0].paymentID;
                    });
                    this.setState({
                        showProgram: true,
                        dateFull: this.formartDate(response.data.program[0].nextRechargeDay),
                        amount: response.data.program[0].value,
                        paymentFlag: response.data.program[0].flag,
                        cpf: response.data.program[0].cpf,
                        date: this.formartDate(response.data.program[0].nextRechargeDay),
                        paymentLastNumber: thisCard[0].digFour,
                        programID: response.data.program[0].programID,

                    });


                    this.countDays(response.data.program[0].nextRechargeDay);
                    break;
                default:
                    // this.setState({loading: 0});
                    Swal.fire({
                        title: 'Erro!',
                        text: response.data.msg,
                        type: 'error',
                        icon: 'error'
                    })
                    break;
            }

        });
    }

    countDays = (date) => {
        var today = new Date();
        var cmas = new Date(date);
        // if (today.getMonth()==11 && today.getDate()>25) 
        // {
        // cmas.setFullYear(cmas.getFullYear()+1); 
        // }  
        var one_day = 1000 * 60 * 60 * 24;
        this.setState({ days: Math.ceil((cmas.getTime() - today.getTime()) / (one_day)) })
    }



    deleteProgram = () => {

        let _self = this;
        axios.post('https://www.pagtel.com.br/Hub360Correios/v2/deleteProgram', {
            transactionId: transactionID('ABO'),
            MSISDN: this.state.clientInfo.number,
            programId: this.state.programID,
            motivoId: this.state.motivoId
        }).then((response) => {
            switch (response.data.code) {
                case 'P00':

                    let { isIntelligentControl } = this.state;

                    Swal.fire({
                        title: 'Sucesso',
                        text: isIntelligentControl ? "Seu plano foi cancelado com sucesso!" : "Recarga programada excluida com sucesso!",
                        imageUrl: successIcon,
                        confirmButtonColor: '#05416B'
                    }).then(() => {
                        localStorage.setItem('clientInfo', JSON.stringify({
                            ...JSON.parse(localStorage.getItem("clientInfo")),
                            isIntelligentControl: false
                        }));
                        this.setState({ redirect: true });
                    });
                    break;
                default:
                    // this.setState({loading: 0});
                    Swal.fire({
                        title: 'Erro!',
                        text: response.data.msg,
                        type: 'error',
                        icon: 'error'
                    })
                    break;
            }
        });
    }



    getCard() {

        this.setState({ loading: 1 });

        axios.post('https://www.pagtel.com.br/Hub360Correios/v2/GetCard', {
            transactionId: transactionID('ABP'),
            MSISDN: this.state.clientInfo.number
        }).then((response) => {
            switch (response.data.code) {
                case 'P00':
                    this.setState({ cardList: response.data.cardList, loading: 0 });
                    this.queryProgram();
                    break;
                default:
                    // this.setState({loading: 0});
                    Swal.fire({
                        title: 'Erro!',
                        text: response.data.msg,
                        type: 'error',
                        icon: 'error'
                    })
                    break;
            }

        });


    }






    closeAndMoveOn = () => {
        this.setState({ redirect: true });
    }

    formatReal(int) {
        var tmp = int + '';
        tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
        if (tmp.length > 6)
            tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");

        return `R$${tmp}`;
    }

    formatPhone(phone) {
        if(phone !== 0) return phone.length > 11 ? phone.slice(2) : phone;
        return "";
    }

    openPolity = async () => {
        let response = await axios.post('https://www.pagtel.com.br/Hub360Correios/v1/GetTextoCancelamento', {
            transactionId: transactionID('ABQ'),
            msisdn: this.state.clientInfo.number,
            source: "web",
        })



        if (response.data.code === "P00")
            this.setState({
                textPolity: response.data.texto,
                whatStep: "textPol"
            })
        else
            Swal.fire({
                title: 'Erro!',
                text: response.data.msg,
                type: 'error',
                icon: 'error'
            })


        // this.setState({
        //     textPolity: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur viverra posuere dolor in iaculis. Integer eget velit lectus. Nunc tristique, lectus ut bibendum dignissim, magna diam feugiat ante, quis luctus odio urna non sem. Fusce imperdiet iaculis ex ac posuere. Quisque porttitor sed ante malesuada blandit. Nam commodo, orci ut iaculis accumsan, lacus ex vulputate turpis, non commodo leo lacus at dolor. Fusce eget nunc tincidunt, congue justo eget, blandit ipsum. Curabitur nec nisl vitae turpis suscipit placerat sit amet eget nisi. Proin vel commodo massa, a luctus magna. Pellentesque rhoncus felis sapien, nec efficitur lacus bibendum eu",
        //     whatStep: "textPol"
        // })
    }

    openListMot = async () => {
        let response = await axios.post('https://www.pagtel.com.br/Hub360Correios/v1/ListMotivoCancelamento', {
            transactionId: transactionID('ABR'),
        })

        if (response.data.code === "P00")
            this.setState({
                textList: response.data.details,
                whatStep: "textList"
            })
        else
            Swal.fire({
                title: 'Erro!',
                text: response.data.msg,
                type: 'error',
                icon: 'error'
            })

        // this.setState({
        //     textList:[
        //         {
        //             "motivoId": "1",
        //             "descricao": "Motivo 1"
        //         },
        //         {
        //             "motivoId": "2",
        //             "descricao": "Motivo 2"
        //         },
        //         {
        //             "motivoId": "3",
        //             "descricao": "Motivo 3"
        //         },
        //         {
        //             "motivoId": "4",
        //             "descricao": "Motivo 4"
        //         },
        //         {
        //             "motivoId": "5",
        //             "descricao": "Motivo 5"
        //         }
        //     ],
        //     whatStep: "textList"
        // })

    }

    backPage = (e, page) => {
        e.preventDefault();
        switch (page) {
            case "textPol":
                this.setState({ whatStep: "init" })
                break;
            case "textList":
                this.setState({ whatStep: "textPol" })
                break;
            default:
                break;
        }
    }

    handlerMotivo = (e) => {
        this.setState({
            motivoId: e.target.value
        })
    }

    componentDidMount() {
        this.getCard();
        let self = this;
        let clientInfo = JSON.parse(localStorage.getItem('clientInfo'));




        setInterval(() => {
            try {
                self.setState({ isIntelligentControl: (clientInfo !== null) ? JSON.parse(localStorage.getItem("clientInfo")).isIntelligentControl : "" });
            } catch (error) {
                console.log(error)
            }

        }, 1000)

    }


    render() {
        let { isIntelligentControl, textPolity, whatStep, textList, motivoId } = this.state;

        var moment = require('moment');
        require('moment/locale/pt');
        var yesterday = moment().subtract(1, 'day' + 1);
        var valid = function (current) {
            return current.isAfter(yesterday);
        };


        if (this.state.redirect) {
            return <Redirect to={{
                pathname: "/home"
            }} />
        }

        return (
            <div>
                <div className="rechargeSteps ">
                    <div className="btn-back">
                        {whatStep === "init"
                            ? <Link to="/home">Voltar </Link>
                            : <a href="#" onClick={(e) => this.backPage(e, whatStep)}>Voltar </a>
                        }

                    </div>

                    <div className="menu--program d-none">
                        <h3>Recarga Programada</h3>
                        <p className="menu--program-date">Próxima recarga: {this.state.dateFull}</p>
                        <div className="menu--program-graph">
                            <ProgressCircleWrapper
                                svgWidth={140}
                                arcWidth={9}
                                progressPercentage={((30 - this.state.days) / 30) * 100} />
                            <div className="left-days">{this.state.days}</div>
                            <div className="left-days-title">Dia para a recarga</div>
                        </div>
                    </div>


                    <div className="content-recharge-step" >

                        <div className="containerRecharge">

                            <div className={`${whatStep === "init" ? "activeOne" : "desactiveOne"} purchase-resume step current`}>
                                {/* <h2>Resumo</h2> */}

                                <ul className="purchase-resume-container">
                                    <li>
                                        <div className="recharge-change-number-container">
                                            <small>Valor</small>
                                        </div>
                                        <div className="d-flex recharge-change-number-display">
                                            
                                            <div>
                                                <p>{this.formatReal(this.state.amount)}</p>

                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="recharge-change-number-container">
                                            <small>Data da próxima recarga</small>
                                        </div>
                                        <p>{(this.state.date)
                                            ? this.state.date.split("/")[0] + "/" + this.state.date.split("/")[1] : ""}</p>
                                    </li>
                                    <li>
                                        <div className="recharge-change-number-container">
                                            <small>Número</small>
                                        </div>
                                        <p>{this.formatPhone(this.state.clientInfo.number)}</p>
                                    </li>
                                    <li>
                                        <div className="recharge-change-number-container">
                                            <small>CPF</small>
                                        </div>
                                        <NumberFormat
                                            className="cpfResumo"
                                            value={this.state.cpf}
                                            placeholder="123.456.789-10"
                                            disabled="disabled"
                                            format="###.###.###-##"
                                        />
                                    </li>
                                    <li>
                                        <div className="recharge-change-number-container">
                                            <small>Pagamento</small>
                                        </div>

                                        <div className="d-flex flex-item-align-center">
                                            <div>
                                                {
                                                    typeof this.state.paymentFlag !== 'undefined'
                                                    && this.state.paymentFlag === '' ||
                                                    <img className="resume-payment-flag" src={require(`../../images/payments/${this.state.paymentFlag.toLocaleLowerCase()}.svg`)} />
                                                }
                                            </div>
                                            <div>
                                                Final {this.state.paymentLastNumber}
                                            </div>
                                        </div>


                                    </li>
                                    <li>
                                        <div className="recharge-change-number-container">
                                            <small>Total</small>
                                            <a href="#" className="recharge-amount-total color-success">{this.formatReal(this.state.amount)}</a>
                                        </div>
                                    </li>
                                </ul>


                                <br />

                                <button className="btn btn-cancelar-recarga active" onClick={this.openPolity} style={{ margin: '0 auto' }}>
                                    {!(isIntelligentControl) ? "Cancelar Recarga" : "Cancelar plano"}
                                </button>

                            </div>

                            <div className={`${whatStep === "textPol" ? "activeOne" : "desactiveOne"} purchase-resume step textPol`}>
                                <h2>Cancelamento</h2>
                                <hr />
                                <p className="textPolity_">{ReactHtmlParser(textPolity)}</p>
                                <button className="btn btn-cancelar-recarga active" onClick={this.openListMot} style={{ margin: '0 auto' }}>
                                    {!(isIntelligentControl) ? "Cancelar Recarga" : "Cancelar plano"}
                                </button>
                            </div>

                            <div className={`${whatStep === "textList" ? "activeOne" : "desactiveOne"} purchase-resume step textList`}>
                                <h2>Cancelamento</h2>
                                <hr />
                                <p className="motivoCancel">informe-nos o motivo do seu cancelamento</p>
                                <ul className="listMotivs">
                                    {textList.map((item, i) => {
                                        return <li key={i}>
                                            <input type="radio" id={item.motivoId} onChange={(e) => this.handlerMotivo(e)} name="motivo" value={item.motivoId}></input>
                                            <label for={item.motivoId}>{item.descricao}</label>
                                        </li>
                                    })}

                                </ul>
                                <button disabled={(this.state.motivoId === "")?"disabled":""} className={`btn btn-cancelar-recarga ${motivoId !== "" && "active"}`} onClick={this.deleteProgram} style={{ margin: '0 auto' }}>
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </div>


                    {this.state.showPopUpSucess &&
                        <div className="container-popupsuccess">
                            <div className="PopUpSucess">
                                <i className="PopUpSucess-icon"></i>
                                <h3>Recarga agenda com sucesso!</h3>
                                <p>A sua recarga no valor de R$ {this.formatReal(this.state.amount)} para o número {this.state.clientInfo.number.replace("55", "")} foi agendada com sucesso 🎉</p>
                                <div className="PopUpSucess-btn" onClick={this.closeAndMoveOn}>Ok</div>
                            </div>
                            <div className="overLay-popup"></div>
                        </div>
                    }
                </div>
                <Loading loading={this.state.loading} />
            </div>
        );
    }

}

export default MyProgramStep